import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FiCheck, FiCopy } from "react-icons/fi";

const DNSTable = ({ token }) => {
  const [copied, setCopied] = useState(false);
  const value = `channels-verification=${token}`;

  return (
    <div className="w-full overflow-hidden rounded-lg border border-theme-chatBackground bg-transparent">
      <table className="w-full table-fixed text-left border-collapse">
        <thead>
          <tr className="border-b border-theme-b-chatBackground bg-theme-chatDivider">
            <th className="w-32 px-4 py-3 text-sm font-medium text-theme-secondaryText border-r border-theme-chatBackground">
              Host
            </th>
            <th className="w-20 px-4 py-3 text-sm font-medium text-theme-secondaryText border-r border-theme-chatBackground">
              Type
            </th>
            <th className="px-4 py-3 text-sm font-medium text-theme-secondaryText">
              Value
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-t border-t-theme-chatBackground">
            <td className="p-4 align-top text-theme-primaryText border-r border-theme-chatBackground whitespace-nowrap">
              @ (leave blank)
            </td>
            <td className="p-4 align-top text-theme-primaryText border-r border-theme-chatBackground">
              TXT
            </td>
            <td className="p-4 align-top text-theme-primaryText">
              <div className="flex items-start gap-2">
                <code className="min-w-0 flex-1 break-all font-mono text-sm">
                  {value}
                </code>
                <CopyToClipboard
                  text={value}
                  onCopy={() => {
                    setCopied(true);
                    setTimeout(() => setCopied(false), 1200);
                  }}
                >
                  <button
                    type="button"
                    className="flex flex-shrink-0 items-center gap-1.5 rounded-md border border-theme-chatDivider px-2.5 py-1 text-xs font-semibold text-theme-primaryText hover:bg-theme-tertiaryBackground"
                  >
                    {copied ? <FiCheck size={13} /> : <FiCopy size={13} />}
                    {copied ? "Copied" : "Copy"}
                  </button>
                </CopyToClipboard>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default DNSTable;
